import { Action              ,
         ActionType          ,
		 AuthenticationState ,
         initialState        }  from './types';

const authenticationReducer = (state: AuthenticationState = initialState, action: Action):AuthenticationState =>
 {
  switch (action.type)
   {
    case ActionType.INIT_AUTHENTICATION: return {
                                                   ...state,
                                                   authentication: {
                                                     ...state.authentication,
                                                     login: "",
                                                     token: "",
                                                     admin: null,
                                                     ...( action.complete ? { numberOfAttempts: 0 } : {} ),
                                                   }
                                                  };

    case ActionType.SET_LOGIN:           return {
                                                   ...state,
                                                   authentication: { ...state.authentication, login: action.login }
                                                  };

    case ActionType.SET_TOKEN:           return {
                                                   ...state,
                                                   authentication: { ...state.authentication, token: action.token }
                                                  };

    case ActionType.SET_ADMIN:           return {
                                                   ...state,
                                                   authentication: { ...state.authentication, admin: action.admin }
                                                  };

    case ActionType.COUNT_ATTEMPT:       return {
                                                   ...state,
                                                   authentication: {
                                                     ...state.authentication,
                                                     numberOfAttempts: state.authentication.numberOfAttempts + 1
                                                   }
                                                  };

    default:                             return state;
   }
 }


export default authenticationReducer;
